import { HistoryStackEntry } from "../types/HistoryStackEntry";
import { NavigationEventType } from "../types/NavigationEventType";
import { PageEnterDetail } from "../types/PageEnterDetail";

interface ProcessNavigateArgs {
  emitEvent: (type: NavigationEventType, detail?: PageEnterDetail) => void;
  fscriptId: string;
  HistoryIndexKey: string;
  historyStack: HistoryStackEntry[];
  HistoryStackKey: string;
  lastKnownIndex: number;
  fscriptSessionId: string;
}

export const processNavigate = ({
  emitEvent,
  fscriptId: _fscriptId,
  HistoryIndexKey,
  historyStack,
  HistoryStackKey,
  lastKnownIndex,
  fscriptSessionId,
}: ProcessNavigateArgs) => {
  const fscriptId = _fscriptId || history.state.fscriptId;
  const detail: PageEnterDetail =
    lastKnownIndex === -1 && historyStack.length === 0
      ? "initial_entry"
      : "navigate_new_page";

  let newCurrentIndex = lastKnownIndex + 1;

  // Remove any entries in the history stack that are beyond the new current index
  // For example, if the user navigated back and then clicked new link
  historyStack = historyStack.slice(0, newCurrentIndex);

  setTimeout(() => {
    historyStack.push({
      url: location.href,
      fscriptId,
    });

    localStorage.setItem(
      HistoryStackKey + fscriptSessionId,
      JSON.stringify(historyStack)
    );
    localStorage.setItem(
      HistoryIndexKey + fscriptSessionId,
      newCurrentIndex.toString()
    );

    const currentState = window.history.state || {};

    const newState = {
      ...currentState,
      fscriptId,
    };

    window.history.replaceState(newState, "");

    emitEvent("page_load", detail);
  }, 0);
};
